import { useProperties } from '../../api/properties';
import {
    Grid, IconButton, Tooltip, Typography
} from '@material-ui/core';
import { PlayCircleOutline } from '@material-ui/icons';
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles } from '@material-ui/core/styles';
import Dimmer from '+/Dimmer';
import History from '#/history';

const useStyles = makeStyles({
    dataGrid: {
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus': {
            outline: 'none'
        }
    },
    redButton: {
        color: '#fff',
        backgroundColor: '#DB2828'
    }
});

const handleRowClick = property_id => {

    History.push(`/unit-types/${property_id}`);


};

const ListProperties = props => {
    const classes = useStyles();
    const {
        isLoading, isError, data, isFetching
    } = useProperties();


    if (isLoading || isFetching) {
        return <Dimmer />;
    }

    if (isError) {
        return 'Internal Error - Contact Technical Support';
    }


    const columns = [
        {
            renderHeader: () => <strong> Name </strong>,
            field: 'name',
            flex: 3
        },
        {
            field: 'actions',
            renderHeader: () => <strong>Actions</strong>,
            renderCell: ({ row }) => (
                <div>
                    <Tooltip title='Run' onClick={() => handleRowClick(row.id) }>
                        <IconButton>
                            <PlayCircleOutline />
                        </IconButton>
                    </Tooltip>

                </div>
            ),
            flex: 1,
            align: 'right',
            headerAlign: 'right'

        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ];


    return (
        <div>
            <div>
                <Grid container justifyContent='space-between' style={{ marginBottom: '10px' }}>
                    <Grid item>
                        <Typography variant='h4'>

                        </Typography>
                    </Grid>

                </Grid>

                <DataGrid
                    className={classes.dataGrid}
                    loading={isLoading}
                    columns={columns}
                    rows={data || []}
                    autoHeight
                    disableSelectionOnClick
                    hideFooterSelectedRowCount
                    hideFooterPagination
                />
            </div>
        </div>
    );
};

export default ListProperties;
